var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71875 4.5L8.0625 6.84375C8.20312 6.98438 8.27344 7.15625 8.27344 7.35938C8.27344 7.5625 8.20312 7.74219 8.0625 7.89844L7.54688 8.41406C7.39062 8.55469 7.21094 8.625 7.00781 8.625C6.80469 8.625 6.63281 8.55469 6.49219 8.41406L4.14844 6.07031L1.80469 8.41406C1.66406 8.55469 1.49219 8.625 1.28906 8.625C1.08594 8.625 0.90625 8.55469 0.75 8.41406L0.234375 7.89844C0.09375 7.74219 0.0234375 7.5625 0.0234375 7.35938C0.0234375 7.15625 0.09375 6.98438 0.234375 6.84375L2.57812 4.5L0.234375 2.15625C0.09375 2.01562 0.0234375 1.84375 0.0234375 1.64062C0.0234375 1.4375 0.09375 1.25781 0.234375 1.10156L0.75 0.585938C0.90625 0.445312 1.08594 0.375 1.28906 0.375C1.49219 0.375 1.66406 0.445312 1.80469 0.585938L4.14844 2.92969L6.49219 0.585938C6.63281 0.445312 6.80469 0.375 7.00781 0.375C7.21094 0.375 7.39062 0.445312 7.54688 0.585938L8.0625 1.10156C8.20312 1.25781 8.27344 1.4375 8.27344 1.64062C8.27344 1.84375 8.20312 2.01562 8.0625 2.15625L5.71875 4.5Z",
    fill: "#8C8C8C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.a00bd2e4.svg";
export { ForwardRef as ReactComponent };